// Prices live in two currencies: Raymon bikes in US dollars, Christmas bikes and accessories in
// pesos. The owner set the rate that puts them on one scale (October 2026): 62 pesos per dollar.
// It only drives the price filter and the "≈" line under a price; every product keeps its real price.
export const DOP_PER_USD = 62;

export const CURRENCIES = {
    usd: { code: 'USD', label: 'USD', step: 10 },
    rd: { code: 'DOP', label: 'RD$', step: 500 }
};

export function toCurrency(amount, fromCode, toCode) {
    if (fromCode === toCode) return amount;
    return fromCode === 'USD' ? amount * DOP_PER_USD : amount / DOP_PER_USD;
}

// A product's price expressed in the chosen scale ('usd' or 'rd'); null when it has no price
export function priceIn(item, key) {
    if (!item.price) return null;
    return toCurrency(item.price, item.currency, CURRENCIES[key].code);
}

// 'USD $1,250' / 'RD$ 36,270'
export function formatMoney(amount, key) {
    const n = Math.round(amount).toLocaleString('en-US');
    return key === 'usd' ? `USD $${n}` : `RD$ ${n}`;
}

// The other currency, rounded, for products priced in the one not chosen: '≈ RD$ 36,270'
export function approxPrice(item, key) {
    if (!item.price || item.currency === CURRENCIES[key].code) return null;
    const value = priceIn(item, key);
    const rounded = key === 'usd' ? Math.round(value) : Math.round(value / 10) * 10;
    return `≈ ${formatMoney(rounded, key)}`;
}

// Lowest and highest price of a list in the chosen scale, widened to whole steps for the slider
export function priceBounds(items, key) {
    const values = items.map((item) => priceIn(item, key)).filter((v) => v);
    if (!values.length) return null;
    const { step } = CURRENCIES[key];
    const min = Math.floor(Math.min(...values) / step) * step;
    const max = Math.ceil(Math.max(...values) / step) * step;
    return { min, max: max > min ? max : min + step, step };
}

// '500-12000' -> { min: 500, max: 12000 }; anything else -> null
export function parseRange(text) {
    const match = /^(\d+)-(\d+)$/.exec(text || '');
    if (!match) return null;
    const min = Number(match[1]);
    const max = Number(match[2]);
    return max > min ? { min, max } : null;
}
